import axios from 'axios';
import { clearAttributesObj } from './utils';

export default function({ customMutations }) {
  return {
    SET_ITEMS: (state, items) => {
      state.items.isLoading = false;
      state.items.data = items;
      state.items.lastRefreshItemsDate = new Date(Date.now());
    },
    UPDATE_ITEM: (state, newItem) => {
      state.items.data = state.items.data.map((item) =>
        item.id === newItem.id ? newItem : item
      );
    },
    UPDATE_ITEMS: (state, newItems) => {
      state.items.data = newItems;
    },
    SET_SELECTED_ITEMS: (state, selectedItems) => {
      state.items.selectedItems = selectedItems;
    },
    SET_ORDER_ASC: (state, isOrderASC) => {
      state.items.sort.ASC = isOrderASC;
    },
    SET_EDIT_MODE: (state, editMode) => {
      state.items.isEditMode = editMode;
    },
    SET_ITEMS_PAGE: (state, page) => {
      state.items.page = page;
    },
    SET_ITEMS_PAGE_SIZE: (state, pageSizeIndex) => {
      state.items.pageSizeIndex = pageSizeIndex;
    },
    SET_ITEMS_SORT_BY: (state, value) => {
      state.items.sort.by = value;
    },
    SET_ITEMS_ERROR: (state, error) => {
      if (!axios.isCancel(error)) {
        state.items.isLoading = false;
        state.items.error = JSON.stringify(error);
      }
    },
    SET_ATTRIBUTES_OBJ: (state, attributesObj) => {
      state.filters = {
        ...state.filters,
        attributesObj:
          attributesObj ||
          clearAttributesObj({
            attributesObjRef: state.attributesObjRef.data,
          }),
      };
    },
    SET_ATTRIBUTES_OBJ_DEFAULT_FILTERS: (state, attributesObj) => {
      state.defaultFilters = {
        ...state.defaultFilters,
        attributesObj:
          attributesObj ||
          clearAttributesObj({
            attributesObjRef: state.attributesObjRef.data,
          }),
      };
    },
    SET_SEARCH_$OR: (state, { attribute, value }) => {
      state.filters.search.$or = {
        ...state.filters.search.$or,
        [attribute]: value,
      };
    },
    SET_SEARCH_$AND: (state, { attribute, value }) => {
      state.filters.search.$and = {
        ...state.filters.search.$and,
        [attribute]: value,
      };
    },
    SET_GLOBAL_SEARCH: (state, value) => {
      state.filters.globalSearch = value;
    },
    SET_SEARCH_EL: (state, { name, value }) => {
      state.filters.search = { ...state.filters.search, [name]: value };
    },
    SET_URL_PARAM_ID: (state, urlParamId) => {
      state.filters = { ...state.filters, urlParamId };
    },
    SET_DATE_MIN: (state, dateMin) => {
      state.filters = { ...state.filters, dateMin };
    },
    SET_DATE_MAX: (state, dateMax) => {
      state.filters = { ...state.filters, dateMax };
    },
    SET_FILTERS_AS_DEFAULT: (state) => {
      state.filters = { ...state.defaultFilters };
    },
    SET_CURRENT: (state, current) => {
      state.current.isLoading = false;
      state.current.data = current;
    },
    UPDATE_CURRENT: (state, current) => {
      state.current.data = current;
    },
    SET_CURRENT_ERROR: (state, error) => {
      state.current.isLoading = false;
      state.current.error = error;
    },
    SET_CURRENT_REQUEST: (state) => {
      state.current.isLoading = true;
      state.current.data = {};
      state.current.error = null;
    },
    SET_ATTRIBUTES_OBJ_REF: (state, val) => {
      state.attributesObjRef.data = val;
    },
    SET_ATTRIBUTES_OBJ_REF_LOADING: (state, isLoading) => {
      state.attributesObjRef.isLoading = isLoading;
    },
    SET_ITEMS_REQUEST: (state, queryParams) => {
      state.items.isLoading = true;
      state.items.data = [];
      const axiosSource = axios.CancelToken.source();
      state.items.request = {
        cancel: axiosSource.cancel,
        token: axiosSource.token,
      };
      state.items.queryParams = queryParams;
      state.items.error = null;
    },
    REMOVE_ITEM: (state, id) => {
      state.items.data = state.items.data.filter((item) => item.id !== id);
    },
    SET_VIEW_TABLE: (state, viewTable) => {
      state.items.isViewTable = viewTable;
    },
    ...customMutations,
  };
}
